import Link from "@/components/ui/intent-link";

export function PrivacyLink({ href }: { href: string }) {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 underline"
    >
      Privacy Policy
      <svg aria-hidden width="10" height="10" viewBox="0 0 12 12" fill="none" className="shrink-0">
        <path
          d="M4 2h6v6M10 2 4.5 7.5M3 5v5h5"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="sr-only">(opens in a new tab)</span>
    </Link>
  );
}
